export default class equipoTecnicosService{

	constructor($http, baseUrl){
		this.http    = $http;
		this.baseUrl = baseUrl;

		this.routes = {
			"all": '/api/teams'
		};
	}

	getAll(filter){
		let url = this.baseUrl + this.routes.all;
		let config = {
			params : filter
		};
		return this.http.get(url, config);
	}

	save(data){
		let url = this.baseUrl + this.routes.all;
		return this.http.post(url, data);
	}
}



// WEBPACK FOOTER //
// ./app/js/services/equiposTecnicos.js